import React, { useEffect, useRef } from 'react';
import {
  PreviewModalTitleContainer,
  PreviewModalTitleText,
  PreviewModalLinkImage,
  StyledPreviewModal,
  StyledVideo,
} from './styles';
import Hls from 'hls.js';
import previewModalLink from './images/mediaPreviewLink.svg';

const PreviewModal = ({ isVisible, videoUrl, onClose }) => {
  const videoRef = useRef(null);
  const hlsInstance = useRef(null);

  useEffect(() => {
    if (isVisible && videoUrl) {
      const videoElement = videoRef.current;
      if (Hls.isSupported()) {
        hlsInstance.current = new Hls();
        hlsInstance.current.loadSource(videoUrl);
        hlsInstance.current.attachMedia(videoElement);
      } else {
        videoElement.src = videoUrl;
      }
    }

    return () => {
      if (hlsInstance.current) {
        hlsInstance.current.destroy();
        hlsInstance.current = null;
      }
    };
  }, [isVisible, videoUrl]);

  return (
    <StyledPreviewModal
      title={
        <PreviewModalTitleContainer>
          <PreviewModalTitleText>Preview</PreviewModalTitleText>
          <a href={videoUrl} target="_blank" rel="noopener noreferrer">
            <PreviewModalLinkImage src={previewModalLink} alt="Open Video Link" />
          </a>
        </PreviewModalTitleContainer>
      }
      visible={isVisible}
      onCancel={onClose}
      footer={null}
      width={624}
    >
      <StyledVideo ref={videoRef} controls />
    </StyledPreviewModal>
  );
};

export default PreviewModal;
